"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var inlineMetric_styles_1 = require("./inlineMetric.styles");
var core_components_1 = require("@securityproducts/core-components");
function InlineMetric(props) {
    var value = props.value === undefined || props.value < 0 ? "0" : props.value.toLocaleString();
    var valueClass = value === "0" ? inlineMetric_styles_1.valueZero : inlineMetric_styles_1.value;
    var containerClass = props.highlighted ? inlineMetric_styles_1.containerHighlighted : inlineMetric_styles_1.container;
    var icon = core_components_1.createIcon({
        shape: props.iconShape,
        fill: props.iconFill,
        stroke: props.iconStroke,
        size: 10,
    });
    var percentage = core_components_1.getPercentage(props.value, props.total);
    return (React.createElement("div", { className: containerClass, "data-qa": "total-calls-metric", id: props.id, "data-qa-highlighted": props.highlighted },
        React.createElement("div", { className: valueClass, id: props.id + "-value", "data-qa": "total-calls-value" }, value),
        React.createElement("div", { className: inlineMetric_styles_1.percentageClass, id: props.id + "-percentage", "data-qa": "total-calls-percentage" },
            "(",
            percentage,
            ")"),
        React.createElement("div", { className: inlineMetric_styles_1.colour, id: props.id + "-icon" }, icon),
        React.createElement("div", { className: inlineMetric_styles_1.text, id: props.id + "-text" },
            props.text,
            " ",
            React.createElement(core_components_1.SectionTitlesTooltip, { id: props.id + "-tooltip", text: props.tooltip }))));
}
exports.InlineMetric = InlineMetric;
